import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { updateFanNotice } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

import { fanInfoService } from '../service/fan-info'

export const useUpdateNotice = (
  userId: number,
  onSuccess?: (notice: string) => void,
) => {
  const creatorId = useUnit($creatorId)
  const toast = useToast()

  return useMutation(
    (notice: string) => fanInfoService.updateNotice(creatorId!, userId, notice),
    {
      onSuccess: (_, notice) => {
        updateFanNotice({ fanId: userId, notice })

        toast.success('Successfully updated notes')
        onSuccess?.(notice)
      },
      onError: (error) => {
        handleError(error, 'Something went wrong while updating notice')
      },
    },
  )
}
